var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifeidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1821_8926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 0C292.8 0 324.8 20.7 340.9 51.1C373.8 41 411 49 437 75C463 101 471 138.3 460.9 171.1C491.3 187.2 512 219.2 512 256C512 292.8 491.3 324.8 460.9 340.9C471 373.8 463 411 437 437C411 463 373.7 471 340.9 460.9C324.8 491.3 292.8 512 256 512C219.2 512 187.2 491.3 171.1 460.9C138.2 471 101 463 75 437C49 411 41 373.7 51.1 340.9C20.7 324.8 0 292.8 0 256C0 219.2 20.7 187.2 51.1 171.1C41 138.2 49 101 75 75C101 49 138.3 41 171.1 51.1C187.2 20.7 219.2 0 256 0ZM353 225C362.4 215.6 362.4 200.4 353 191.1C343.6 181.8 328.4 181.7 319.1 191.1L224.1 286.1L185.1 247.1C175.7 237.7 160.5 237.7 151.2 247.1C141.9 256.5 141.8 271.7 151.2 281L207.2 337C216.6 346.4 231.8 346.4 241.1 337L353 225Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1821_8926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifeidIcon);
export default __webpack_public_path__ + "static/media/verifeid-icon.9efe7e45ff77d2e20a6ff2ccfa839cff.svg";
export { ForwardRef as ReactComponent };